import React, { useEffect, useState } from "react";
import Card from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Unstable_Grid2";
import { useDispatch, useSelector } from "react-redux";
import { CHANGE_ORDER } from "../../redux/types";

const Carding = (props) => {
  const [color, setColor] = useState("primary");
  const selectedColor = useSelector((state) => state.orderReducers.orderId);
  useEffect(() => {
    setColor(selectedColor === props.orderId ? "secondary" : "primary");
  }, [selectedColor]);

  //test
  useEffect(() => {
    console.log(props.orderId);
  }, []);

  const dispatch = useDispatch();
  return (
    <React.Fragment>
      <Grid md={3} xs={12}>
        <Card>
          <CardContent>
            <Typography color={color} gutterBottom>
              {props.orderType}
              <hr />
            </Typography>
            <Typography sx={{ mb: 1 }} variant="body1" component="div">
              نام بیمار
            </Typography>
            <Typography sx={{ mb: 1 }} variant="body2" component="div">
              {props.patientName}
            </Typography>
            <Typography sx={{ mb: 1 }} variant="body1" component="div">
              نام پزشک
            </Typography>
            <Typography sx={{ mb: 1.5 }} variant="body2" component="div">
              {props.doctorName}
            </Typography>
            <Typography sx={{ mb: 1 }} variant="body1" component="div">
              شماره جعبه{" "}
            </Typography>
            <Typography variant="body2">{props.boxNumber}</Typography>
          </CardContent>
          <CardActions>
            <Button
              size="small"
              fullWidth
              variant="contained"
              color={color}
              sx={{ mb: 1 }}
              onClick={() => {
                dispatch({
                  type: CHANGE_ORDER,
                  payload: props.orderId,
                });
              }}
            >
              انتخاب
            </Button>
          </CardActions>
        </Card>
      </Grid>
    </React.Fragment>
  );
};

export default Carding;
